import React from "react";
import SubHeader from "../general/SubHeader";
import Raj from "../../assets/member/RajKumarMishra.jpg";

const RajKumar = () => {
  return (
    <>
      <SubHeader message="Members" />

      <section className="my-5">
        <div className="container text-center">
          <div className="sec-subheading">
            <hr />
            <span>Members</span>
            <hr />
          </div>
          <p className="sec-heading">Our Management Group</p>

          <div className="member-area row mt-5">
            <div className="col-lg-4 col-12 my-3 pe-lg-0">
              <img
                src={Raj}
                className="img-fluid border-0 rounded"
                alt="Agents"
              />
            </div>

            <div className="col-lg-8 col-12 my-3 text-muted">
              <div className="member-info">
                <p className="fw-bold fs-5 my-0 text-dark">Raj Kumar Mishra</p>
                <span>Operational Head</span>
                <br />
                <p className="mt-3 para-text fw-bold">
                  Education: MA (ENGLISH) , B. ED, D. PHARMA
                  <br />
                  Experience: SOCIAL WORKER, SANSTHAPAK NGO KATKA CLUB SAMAJIK
                  SANSTHA (REGD.), Wholesale medicine supplier
                  <br />
                  Achievement: Asia book of World Record holder, achieved
                  various certificates in social work activities
                </p>

                <p>
                  With an academic background that includes an M.A. in English,
                  a B.Ed., and a D. Pharma, he brings a well-rounded skill set
                  to the organization. Raj’s professional journey spans various
                  fields, including social work, business, and community
                  service. As a social worker and the founder of the NGO Katka
                  Club Samajik Sanstha (Regd.), he has dedicated himself to
                  improving society through numerous outreach programs.
                  <br />
                  <br />
                  <strong>
                    He is the Operational Head at Swalok Group, where he
                    leverages his diverse expertise to manage and streamline
                    operations.
                  </strong>
                  <br />
                  <br />
                  In addition to his social work, Raj has experience as a
                  wholesale medicine supplier, adding a business perspective to
                  his profile. He is a proud holder of the Asia Book of World
                  Records and has earned multiple certificates for his
                  outstanding contributions to social causes. Raj's leadership
                  and dedication to service have made him a pivotal part of
                  Swalok Group’s success, driving its operations forward with
                  passion and commitment.
                </p>
              </div>
            </div>
          </div>
          {/* row ends */}
        </div>
      </section>
    </>
  );
};

export default RajKumar;
